var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto my-12 carrd",attrs:{"tile":""}},[_c('v-card-title',[_c('h5',[_c('v-chip',{staticClass:"chiip",attrs:{"dark":"","large":""}},[_vm._v(_vm._s(_vm.stat))]),_vm._v(" "+_vm._s(_vm.title))],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }